import BrieIcon from "./BrieIcon";
import AppSelectableAction from "../../elements/AppSelectableAction";
import { useAtomValue, useSetAtom } from "jotai";
import { isBrieDisabledAtom } from "../../atoms/GlobalAtoms";
import { brieMenuPageAtom } from "./BrieChatMenuButton";

const BrieHome = () => {
  const setPage = useSetAtom(brieMenuPageAtom);
  const isBrieDisabled = useAtomValue(isBrieDisabledAtom);

  return (
    <>
      {!isBrieDisabled && (
        <div className="brie-intro-container">
          <div className="brie-intro">
            <div className="brie-icon">
              <BrieIcon />
            </div>
            <h3>Hi! I am Brie, your GrowthCloud assistant</h3>
            <span>How can I help you today?</span>
          </div>
        </div>
      )}
      <div className="brie-home">
        <div className="text-uppercase font-weight-500 text-light mt-3">
          Assistance
        </div>
        {!isBrieDisabled && (
          <AppSelectableAction
            leftIcon="mdi mdi-comment-text-outline"
            title="Chat with Brie"
            onClick={() => setPage("messages")}
          />
        )}
        <AppSelectableAction
          leftIcon="mdi mdi-comment-quote-outline"
          title="Give Feedback"
          onClick={() => setPage("chat-feedback")}
        />
        {/* <AppSelectableAction
          leftIcon="mdi mdi-help-circle-outline"
          title="Get Help / Support"
          onClick={() => setPage("support")}
        /> */}
        {/* <div className="text-uppercase font-weight-500 text-light mt-2">
          Quick Actions
        </div>
        <AppSelectableAction
          leftIcon="mdi mdi-view-dashboard-outline"
          title="Create a Workspace"
          onClick={() => setPage("support")}
        />
        <AppSelectableAction
          leftIcon="mdi mdi-plus-circle"
          leftIconCSS="text-primary"
          title="Create a Quick Note"
          onClick={() => setPage("support")}
        />
        <AppSelectableAction
          leftIcon="mdi mdi-account"
          title="Account Settings"
          onClick={() => setPage("support")}
        />
        <AppSelectableAction
          leftIcon="mdi mdi-cloud"
          title="Switch Clouds"
          onClick={() => setPage("support")}
        /> */}
      </div>
    </>
  );
};

export default BrieHome;
